import type { MapClusterProps } from "./map-cluster.type";

import { useMapClusterHanlder } from "./map-cluster.hook";

const MapCluster = (props: MapClusterProps) => {
  useMapClusterHanlder(props);

  return null;
};

export default MapCluster;
